import React from "react";
import PropTypes from "prop-types";
import * as msal from "@azure/msal-browser";
// import { ReCaptcha } from "react-recaptcha-v3";
import cx from "classnames";
import { Form, Button } from "antd";
import {
    formHasErrors,
    getErrorOnField,
    submitForm,
    fieldGenerator
} from "utilities/form";
import { AUTH_FORM_FIELDS } from "constants";
import _lower from "lodash/toLower";
import "styles/form.css";
import Microsoft_logo from "assets/microsoft.png";

const createFormField = Form.createFormField;
const FormItem = Form.Item;
const msalConfig = {
    auth: {
        clientId: process.env.CLIENT_ID,
        authority: "https://login.microsoftonline.com/ebda27e9-560f-48c1-bf94-2119f83863d6",
        redirectUri: "https://soul.progfin.com/auth",
    },
};
const msalInstance = new msal.PublicClientApplication(msalConfig);
class AuthForm extends React.Component {
   state = {
        msLoginInProgress: false, 
    };

    hasErrors = formHasErrors.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, (values) => {
        if(!values.username.includes("@progfin.com") && !values.username.includes("@progcap.com") && !values.username.includes("@progfin.in") && !values.username.includes("@dispostable")) {
            this.props.askBankUser(values.username);
            return;
        }
        const { props } = this;
        window.grecaptcha.ready(function() {
            return window.grecaptcha.execute(process.env.RECAPTCHA_SITE_KEY, {action : "submit"}).then((token) => {
                props.submitValues({...values, username: _lower(values.username), recaptchaToken: token});
                return token;
            }).catch(() => {
                // console.error(err);
            });
        });
    }
    );
  loginWithMicrosoft = async () => {
    this.setState({ msLoginInProgress: true });
    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });
      const microsoftAuthResponse = {
        access_token: loginResponse.accessToken,
        id_token: loginResponse.idToken,
        token_type: loginResponse.tokenType,
      };
      const recaptchaToken = await window.grecaptcha.execute(
        process.env.RECAPTCHA_SITE_KEY,
        { action: "login" }
      );
    this.props.submitValues({ username: "", password: "", recaptchaToken, microsoftAuthResponse,});
    this.setState({ msLoginInProgress: false })
  } 
  catch (err) {
    console.error(err);
    this.setState({ msLoginInProgress: false });
  }  
  };
    fieldGenerator = fieldGenerator.bind(this.props.form);
    
    render() {
        return (
            <Form
                onSubmit={this.handleFormSubmit}
                className={cx("form", "br-3")}
            >
                {AUTH_FORM_FIELDS.map((field, fieldName) =>
                    this.fieldGenerator(
                        fieldName,
                        field,
                        this.getErrorOnField(fieldName)
                    )()
                )
                    .toList()
                    .toJS()}
                <FormItem>
                    <Button type="primary"
                        className={"g-recaptcha"}
                        block
                        htmlType="submit"
                        loading={this.props.formSubmitting && !this.state.msLoginInProgress}
                    >
                        Login
                    </Button>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        margin: "16px 0",
                        color: "#888",
                        fontWeight: 500,
                        fontSize: "14px"
                    }}
                    >
                        <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
                        <span style={{ padding: "0 10px" }}>OR</span>
                        <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
                    </div>
                    <Button
                        className={"g-recaptcha"}
                        block
                        onClick={this.loginWithMicrosoft}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                        }}
                    >
                        <img
                            src={Microsoft_logo}
                            alt="Microsoft Logo"
                            width={20}
                            height={20}
                            style={{ display: "inline-block", }}
                        />
                        Login with Microsoft
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

AuthForm.defaultProps = {
    formSubmitting: false
};

AuthForm.propTypes = {
    id: PropTypes.string,
    values: PropTypes.object,
    errors: PropTypes.object,
    form: PropTypes.object,
    formSubmit: PropTypes.func,
    formSubmitting: PropTypes.bool,
    submitValues: PropTypes.func,
    askBankUser: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values, errors }) => {
        if (values && values.size) {
            return values
                .map((_, fieldName) =>
                    createFormField({
                        value: _,
                        errors: errors && errors.get(fieldName)
                    })
                )
                .toJS();
        }
    }
})(AuthForm);
